import React from "react";
import { useNav } from "../context/NavContext";

interface Props {
  rewardPts: number;
  lang: "es" | "en";
  authed?: boolean;
}

/**
 * Compact loyalty pill displayed in the TopBar. Only renders when the user
 * is signed in and has a positive balance. Clicking takes the user to the
 * rewards page.
 */
export function LoyaltyPill({ rewardPts, lang, authed }: Props) {
  const { nav } = useNav();
  if (!authed) return null;
  const hasPts = rewardPts > 0;
  const label = "pts";
  return (
    <button
      type="button"
      onClick={() => nav("rewards")}
      data-testid="loyalty-pill"
      aria-label={hasPts
        ? (lang === "es" ? `Tienes ${rewardPts} puntos` : `You have ${rewardPts} points`)
        : (lang === "es" ? "Empieza a ganar puntos" : "Start earning points")}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        padding: "4px 9px",
        height: 28,
        borderRadius: 999,
        background: hasPts
          ? "linear-gradient(135deg, #F5D547 0%, #E0A800 100%)"
          : "var(--bg3)",
        color: hasPts ? "#3D2A00" : "var(--tx2)",
        fontWeight: 700,
        fontSize: 11,
        border: hasPts ? "none" : "1px solid var(--bd)",
        cursor: "pointer",
        boxShadow: hasPts ? "0 2px 6px rgba(224,168,0,.35)" : "none",
        whiteSpace: "nowrap",
      }}
    >
      <span aria-hidden style={{ fontSize: 12 }}>★</span>
      {hasPts
        ? `${rewardPts.toLocaleString("en-US")} ${label}`
        : (lang === "es" ? "Gana pts" : "Earn pts")}
    </button>
  );
}